﻿import {Delegate} from "../Tools/Delegate.js";
import {IDisposableLike} from "../Tools/Disposable/IDisposableLike";

export class ComponentPanel implements IDisposableLike {
        public WindowContainer: JQuery | undefined;
        protected jqMainContainer: JQuery | undefined;
        #_titre : string | undefined;
        #jqWindow : JQuery | undefined;
        #kWindow : kendo.ui.Window | undefined;
        #object : IComponentPanelObject | undefined;
        
        public OnDispose = new Delegate();
        
        constructor(option: IComponentPanelOption) {
            this.jqMainContainer = option.jqMainContainer;
            this.#_titre = option.titre;
        }
        
        public get Titre() {
            return this.#_titre;
        }
        
      public set Titre(value: string | undefined) {
            this.#kWindow.title(value);
            this.#_titre = value;
      }
        
        public Close = () => {
            this.#kWindow.close();
        }
        
      public Dispose =  () => {
            this.#kWindow.destroy();
            this.#object.Dispose();
      }
        
        public  Open = async (object? : IComponentPanelObject) => {
            if (object != null) {
                {
                    this.#object = object;
                    object.MainContainer = this.WindowContainer;
                    object.Init();
                }
            }
            this.#kWindow.open();
            return this;
        }
        
        public Maximize = async () => {
            this.#kWindow.maximize();
            return this;
        }
        
      public SetOption = async (options: any) => {
          this.#kWindow.setOptions(options);
      }
        
        public Init = async () => {
            await this.#buildWindow()
            return this;
        }
       
        #buildWindow = async() => {
            this.#jqWindow = $("<div></div>");
            this.#kWindow = this.#jqWindow.kendoWindow({
                title: this.Titre,
                visible: false,
                animation: false,
                draggable: {containment: this.jqMainContainer},
                actions: ["maximize","Close"],
                width: "60%",
                minWidth: 500,
                height: "100%",
                position: {top: 0, left: "40%"},
                appendTo: this.jqMainContainer,
                close : async () => this.Dispose()
            }).data("kendoWindow");
            
            this.WindowContainer = this.#kWindow.element;
        }
    }
    
    export interface IComponentPanelOption {
        jqMainContainer: JQuery;
        titre? : string | undefined; 
    }
    
    export interface IComponentPanelObject extends IDisposableLike {
        Init : () => void;
        MainContainer: JQuery;
        Titre?: string | undefined;
    }
